interface IconBoxProps {
  hasBadge?: boolean;
  badgeText?: string;
  iconBoxBg?: string;
  iconClass: string;
  iconLabel: string;
}

export const IconBox = ({
  hasBadge,
  badgeText,
  iconBoxBg = 'bg-black',
  iconClass,
  iconLabel,
}: IconBoxProps) => {
  return (
    <>
      <div className="col-12 col-sm-4">
        <div
          className={`d-flex justify-content-center flex-column 
					${hasBadge === true ? 'py-3 px-3 pt-0' : 'p-3'} h-100 ${iconBoxBg}`}
        >
          {hasBadge && (
            <div className="badge bg-warning position-relative top-0 start-50 translate-middle w-25">
              {badgeText}
            </div>
          )}
          <div className={`${iconClass} d-flex justify-content-center`}></div>
          <code className="d-flex justify-content-center w-100 mt-2">
            {iconLabel}
          </code>
        </div>
      </div>
    </>
  );
};
